<template>
  <mdb-navbar class="yellow darken-2 lighten-3" dark>
    <mdb-navbar-brand to="/Home" active>
      <img src="../assets/thitch_logo.png" height="30" alt="thitch logo" />
    </mdb-navbar-brand>
    <mdb-navbar-toggler>
      <mdb-navbar-nav>
        
        <!-- <mdb-nav-item to="/dashboard" active>Dashboard</mdb-nav-item> -->

        <!-- <mdb-nav-item href="#">Features</mdb-nav-item>
        <mdb-nav-item href="#">Pricing</mdb-nav-item>
        <mdb-dropdown tag="li" class="nav-item">
          <mdb-dropdown-toggle tag="a" navLink color="indigo" slot="toggle" waves-fixed>Dropdown</mdb-dropdown-toggle>
          <mdb-dropdown-menu>
            <mdb-dropdown-item>Action</mdb-dropdown-item>
            <mdb-dropdown-item>Another action</mdb-dropdown-item>
            <mdb-dropdown-item>Something else here</mdb-dropdown-item>
          </mdb-dropdown-menu>
        </mdb-dropdown>-->
      </mdb-navbar-nav>
      <router-link to="/dashboard" class="#00796b teal darken-2 btn btn-default ripple-parent" tag="button">Dashboard</router-link>
      <mdb-btn class="#f9a825 yellow darken-3" v-on:click="logout()">Logout</mdb-btn>
    </mdb-navbar-toggler>
  </mdb-navbar>
</template>

<script>
import {
  mdbNavbar,
  mdbNavbarBrand,
  mdbNavbarToggler,
  mdbNavbarNav,
  //mdbNavItem,
  mdbBtn
} from "mdbvue";
//mdbDropdown, mdbDropdownMenu, mdbDropdownToggle, mdbInput, mdbDropdownItem,
export default {
  name: "navigation",
  components: {
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavbarToggler,
    mdbNavbarNav,
    //mdbNavItem,
    // mdbDropdown,
    // mdbDropdownMenu,
    // mdbDropdownToggle,
    // mdbDropdownItem,
    // mdbInput,
    mdbBtn
  },
  methods: {
    logout: function() {
      this.$session.destroy();
      this.$router.replace({ name: "login" });
    }
  }
};
</script>
<style scoped>

.navbar.navbar-dark .navbar-nav .nav-item .nav-link {
  color: #000000 !important;
}

nav ul li a:hover {
  color: orange;
}

</style>